

export const frontMatter = {
	sidebar_position: 6,
	license: 'republish',
	author: 'Jan van Steenbergen',
	origin: 'http://steen.free.fr/interslavic/relay.html',
	description: 'Explore the Pan-Slavic Relay, a game played by conlangers, and the original English text by Mary Russel Mitford, written in the first half of the XIX century.',
	tags: [
		'conlanging',
		'pan-slavic',
		'relay',
		'game',
		'poetry',
		'translation',
		'constructed languages',
		'slavic languages',
		'auxiliary languages',
		'interslavic',
		'slovianski',
		'slovio',
		'slavski',
		'slovioski',
		'pan-slavic relay',
		'mary russel mitford'
	]
};
export const contentTitle = 'The Pan-Slavic Relay';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-docs-learn-misc-pan-slavic-relay-md-0a3.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [{
  "value": "Original English text",
  "id": "original-english-text",
  "level": 2
}, {
  "value": "Andrej Moraczewski – Slovianski",
  "id": "moraczewski-slovianski",
  "level": 2
}, {
  "value": "Naše selo",
  "id": "moraczewski-lat",
  "level": 3
}, {
  "value": "Наше село",
  "id": "moraczewski-cyr",
  "level": 3
}, {
  "value": "Our Village (English translation by Steeven Radzikowski)",
  "id": "our-village-en",
  "level": 3
}, {
  "value": "Steeven Radzikowski – Slovioski",
  "id": "radzikowski-slovioski",
  "level": 2
}, {
  "value": "Našjo Selo",
  "id": "radzikowski-lat",
  "level": 3
}, {
  "value": "Jack Raven – Slovio",
  "id": "raven-slovio",
  "level": 2
}, {
  "value": "Nasx Malgrod",
  "id": "raven-lat",
  "level": 3
}, {
  "value": "Rostislav Levčenko – Slovianski",
  "id": "levcenko-slovianski",
  "level": 2
}, {
  "value": "Naše selo",
  "id": "levcenko-lat",
  "level": 3
}, {
  "value": "Jukka Hintsala – Slavski.",
  "id": "hintsala-slavski",
  "level": 2
}, {
  "value": "Naše selo",
  "id": "hintsala-lat",
  "level": 3
}, {
  "value": "Jan van Steenbergen – Slovianski",
  "id": "steenbergen-slovianski",
  "level": 2
}, {
  "value": "Naše selo",
  "id": "steenbergen-slovianski-lat",
  "level": 3
}, {
  "value": "Наше село",
  "id": "steenbergen-slovianski-cyr",
  "level": 3
}, {
  "value": "Michal Borovička – Slovioski",
  "id": "borovicka-slovioski",
  "level": 2
}, {
  "value": "Našje selo",
  "id": "borovicka-lat",
  "level": 3
}, {
  "value": "Igor Polyakov – Slovianski",
  "id": "polyakov-slovianski",
  "level": 2
}, {
  "value": "Naše selo",
  "id": "polyakov-lat",
  "level": 3
}, {
  "value": "After the conclusion of the Relay game, a few translations have been added afterwards:",
  "id": "later-additions",
  "level": 4
}, {
  "value": "Vojtěch Merunka – Novoslovienski",
  "id": "merunka-novoslovienski",
  "level": 2
}, {
  "value": "Naše selo",
  "id": "merunka-novoslovienski-lat",
  "level": 3
}, {
  "value": "Jan van Steenbergen – Slovianto",
  "id": "steenbergen-slovianto",
  "level": 2
}, {
  "value": "Naš selo",
  "id": "steenbergen-slovianto-lat",
  "level": 3
}, {
  "value": "Наш село",
  "id": "steenbergen-slovianto-cyr",
  "level": 3
}, {
  "value": "Vojtěch Merunka – Novoslovienski (reformed)",
  "id": "merunka-novoslovienski-reformed",
  "level": 2
}, {
  "value": "Naše selo",
  "id": "merunka-novoslovienski-reformed-lat",
  "level": 3
}, {
  "value": "Наше село",
  "id": "merunka-novoslovienski-reformed-cyr",
  "level": 3
}];
function _createMdxContent(props) {
  const _components = {
    div: "div",
    em: "em",
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    header: "header",
    hr: "hr",
    p: "p",
    span: "span",
    ..._provideComponents(),
    ...props.components
  }, {CustomAfterSection, CustomBeforeSection} = _components;
  if (!CustomAfterSection) _missingMdxReference("CustomAfterSection", true);
  if (!CustomBeforeSection) _missingMdxReference("CustomBeforeSection", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.header, {
      children: _jsx(_components.h1, {
        id: "the-pan-slavic-relay",
        children: "The Pan-Slavic Relay"
      })
    }), "\n", _jsx(_components.p, {
      children: "The Pan-Slavic Relay took place in September-October 2009."
    }), "\n", _jsx(_components.p, {
      children: "A \"Relay game\" is essentially a variation on the telephone game: one writes a poem or a short passage in his constructed language, and passes it on to the next participant. That person decyphers the text and subsequently sends a translation in his or her language to the next in line, and on and on until it returns full circle, altered, transformed, as it were, by the gods, and containing new wisdom. This game has been played by conlangers almost twenty times now. This relay is somewhat different from other relays, because it consists of Slavic auxiliary languages only. Each participant had 48 hours to complete the task. If his language used multiple orthographies (i.e. Latin vs. Cyrillic), he could of course send both."
    }), "\n", _jsx(_components.h2, {
      id: "original-english-text",
      children: "Original English text"
    }), "\n", _jsx(CustomBeforeSection, {}), "\n", _jsx(_components.p, {
      children: _jsx(_components.em, {
        children: "Here is the original English text by Mary Russel Mitford, written in the first half of the XIX century. Of course, it was shortened and some expressions that were too hard to express in a Slavic conlang were simplified."
      })
    }), "\n", _jsx(_components.p, {
      children: "Of all situations for a constant residence, that which appears to me most delightful is a little village far in the country, a small neighbourhood, not of fine mansions finely peopled, but of cottages and cottage-like house, <...> such ignoble and non-descript dwellings, with inhabitans whose faces are as familiar to us as the flowers in our garden; a little world of our own, close-packed and insulated like ants in an ant-hill, or bees in a hive, or sheep in a fold, or nuns in a convent, or sailors in a ship; where we know every one, are known to every one, interested in every one, and authorised to hope that every one feels an interest in us. How pleasant it is to slide into these true-hearted feelings from the kindly and unconscious influence of habit, and to learn to know and to love people about us, with all their peculiarities, just as we learn to know and to love the nooks and turns of the shady lanes and sunny commons that we pass every day. <...> And a small neighbourhood is as good in sober waking reality as in poetry or prose; a billage neighbourhood, <...> a long winding street at the bottom of a fine eminence, with a road through it, always abounding in carts, horsemen, and carriages. <...> Will you walk with me through our village, courteous reader? The journey is not long. We will begin at the lower end, and proceed up the hill."
    }), "\n", _jsx(_components.h2, {
      id: "moraczewski-slovianski",
      children: "Andrej Moraczewski – Slovianski"
    }), "\n", _jsx(_components.h3, {
      id: "moraczewski-lat",
      children: _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: "Naše selo"
      })
    }), "\n", _jsx(_components.div, {
      className: "notranslate",
      translate: "no",
      children: _jsx(_components.p, {
        children: "Od vsih vozmožnosť postojanogo prebivanja, to, čo javi se mi najviše radostnim, je malo selo daleko od grodskogo šuma; malo sosedstvo. To sut ne polno-naselene mnogokomnatne domi, ale drevene seľske domiki, tute proste i ne-opisujeme žilišča, s obitateľami, čii lica sut tak dobro znane, kak cveti v našom sade; mali osobni svet, tesno sjedineni i zatvoreni, kak mrovki v mrovišče, ili pčeli v uľe, ili ovci v ovčarňe, ili mniški v konvente, ili moreplavateľ na korabľe; gde vsaki znaje vsakogo i je znani dľa vsakogo; interesuje se vsakim, i je dozvoleni imať nadeju, že každi čuje interes do njego. Koľko že je radostno zanuriť v tute istine serdečne čutenja milogo i nevedomogo vpliva privičaja, i poznať i poľubiť vseh ľudov okolo nas, so vsimi ih osobenosťami, prosto kak mi poznavamo i ľubimo zakutki i povroti tenistih ulic i solnečne luki, ktore mi prohodimo každi deň. I malo společenstvo je najviše dobro kak v trezvoj stvornosti, tak i v poezii ili proze; seľsko sosedstvo; dolga, rozprostranjena motajuča se ulica u podnožja miloj vozvišinosti, s cestoju poprek, vsegda zapolnenoj vozami i konnikami. Ne želate li vi projdeť so mnoju prez naše selo, ľubezni čitateľ? Putovanje ne bude dolgim. Mi počnemo na doľnom konce, i prodolžimo na vzgorje."
      })
    }), "\n", _jsx(_components.h3, {
      id: "moraczewski-cyr",
      children: _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: "Наше село"
      })
    }), "\n", _jsx(_components.div, {
      className: "notranslate",
      translate: "no",
      children: _jsx(_components.p, {
        children: "Од всих возможность постояного пребиваня то, чо яви се ми найвише радостним, є мало село далеко од гродского шума; мало соседство. То сут не полно-населене многокомнатне доми, але древене сельске домики, туте просте и не-описуєме жилишча, с обитателями, чии лица сут так добро знане, как цвети в нашом саде; мали особни свет, тесно сьединени и затворени, как мровки в мровишче, или пчели в улье, или овци в овчарнье, или мнишка в конвенте, или мореплаватель на кораблье; где всаки знає всакого и є знани для всакого; интересує се всаким, и є дозволени имать надею, же кажди чує интерес до ньего. Колько же є радостно занурить в туте истине сердечне чутеня милого и неведомого вплива привичая, и познать и полюбить всех людов около нас, со всими их особеностями, просто как ми познавамо и любимо закутки и повроти тенистих улиц и солнечне луки, кторе ми проходимо кажди день. И мало сполеченство є найвише добро как в трезвой створности, так и в поезии или прозе; сельско соседство; долга, розпространьена мотаюча се улица у подножя милой возвишиности, с цестою попрек, всегда заполненой возами и конниками. Не желате ли ви пройдеть со мною през наше село, любезни читатель? Путованье не буде долгим. Ми почнемо на дольном конце, и продолжимо на взгорье."
      })
    }), "\n", _jsx(_components.h3, {
      id: "our-village-en",
      children: "Our Village (English translation by Steeven Radzikowski)"
    }), "\n", _jsx(_components.p, {
      children: "Of all the possible ideal places to live, the one that pleases me most, is a small village that is far from the noise of the city; a little neighborhood. There are no crowded multi-room buildings there, only small wooden cottages – simple and indescribable dwellings, with occupants whose faces are very familiar, much like the flowers in our garden; a world with few people, closely united and shut off, like ants in an ant colony, or bees in a hive, or sheep in a sheep-fold, or nuns in a convent, or sailors on a ship; where everyone knows everyone else and is known by everyone; is interested in everybody, and is permitted to have hope that others are interested in him.\nHow joyful it would be to immerse oneself into these genuine, warm-hearted feelings of a dear and unknown influence of habit, to meet and grow fond of the people around us, with all of their characteristics, just like we are familiar and love the corners and turns of the shady streets and sunny meadows that we pass every day.\nIndeed, a small society is best appreciated in its true form; the same as with poetry or prose; a rural neighborhood; a long, stretched out wandering street at the foot of a lovely hillside with a pathway across it, always filled with carts and horsemen. Do you not wish to travel with me through our village, dear reader? The journey will not be long. We begin at the end of the valley and finish in the hills."
    }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.h2, {
      id: "radzikowski-slovioski",
      children: "Steeven Radzikowski – Slovioski"
    }), "\n", _jsx(_components.h3, {
      id: "radzikowski-lat",
      children: _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: "Našjo Selo"
      })
    }), "\n", _jsx(_components.div, {
      className: "notranslate",
      translate: "no",
      children: _jsx(_components.p, {
        children: "Ot vseh možnih idealnih mestum domovit, to ktorjo mne najvinše radosti, jes maljo selo dalekuo ot šumu velgroda; maljo sosedstvo. U njego ne sou libkaj perepolnih mnoguokomantnih domi; tolko seloje drevonje domki – prostnje i neopisanje domovenii, so obitatelami čoje lici sou velme poznalnuo, tak kak ksveti v našju ogrodu/sadu; svet so nemnogami obsobami, blizuo sojedilnje i zatvorilnje – kak muravi v muravištiu, ili pčeli v pčeldomu, ili ovci vo ovecdomu, ili monahici v monahdomu, ili korabniki na korabu; gde vsekto zna vsektum i znatnjo po vsektum; intersova-se vsektem, i pozvoli-se imat nadežu že inni nim zainteresovajut-se.\nKak radostnuo bilo bi zanurit-se v tutje pravdavernje serdečnje čutenii mila i neznala vlivu privika, i vstretit i zaspriatelit s vseh ludiami okolo nas, so vsemi ih osobnostami, tak kak mi jeseme poznalnuo i lubovime so kutami i povrotami tienih ulicum i suncenih lukum ktorje mi prohodime každij den.\nUverenuo, malij společnost jes najlepšij ocenitnij v svoju pravdnju formu; tak samo s poeziem i prozem; seljo sosedstvo; dolgja raztiagalnja perezbludilnja ulica u dnoju milju pogorka, s putem črezidetcij, vsekda polnilnij vozekami i konnikami. Le vi ne želate putovat s mne skroz našjo selo, udragij čitatel? Putovanie ne bude dolguo. Mi začame na konecu dolina i vivodime na gorum."
      })
    }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.h2, {
      id: "raven-slovio",
      children: "Jack Raven – Slovio"
    }), "\n", _jsx(_components.h3, {
      id: "raven-lat",
      children: _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: "Nasx Malgrod"
      })
    }), "\n", _jsx(_components.div, {
      className: "notranslate",
      translate: "no",
      children: _jsx(_components.p, {
        children: "Ot vse mozxju idealju mestis domovit, to ktor me maks radostijt, es malju malgrod dalekuo ot sxum velgroduf; malju sosedstvo. On ne ima libkai perepolnju mnoguo-komnatju domis; tolko malju drevnoju budkis – prostju i neopisanju domovenies, so obitatelis cxoi licis esijut velme poznalnuo, tak kak kvitis v nasx ogrod; svet s nemnoguo obsobnikis, blizuo sodinju i zakritilju – kak muravis v muravisxtie, ili pcxelis v pcxeldom, ili ovecis vo ovecdom, ili monahicis v monahdom, ili korabnikis na korab; gde vsekto znajt vsektuf i es znalju po vsektuf; es intersovalju vsektifs, i es pozvolilju imat nadezx zxe inis es interesovalju onuf.\nKak radostnuo bil bi zanurit seba v tut pravdavernju serdecxju cxutenies om milju i neznalju vliv privikuf, i vstretit i spriatelit so vse ludis okolo nams, so vse onivoi osobnostis, tak kak mi esime poznalnuo so i lubovime so kutkis i povrotis om tienju ulicis i suncenju lukis ktor mi prohodime kazxd den.\nUverenuo, malju socialgrup es naidobrju ocenilju vo svoi pravdaju form; tak odnakuo s poezia i proze; seloju sosedstvo; dolgju raztiagalju perezbludilju ulica u dnoju milju goracxef, s put ktor onaf cxrezidijt, vsegda polnilju s vozekis i konnikis. Li vi ne zxelajte putovat s me skroz nasx malgrod, udragju cxitatel? Putovanie ne budejt dolguo. Mi zacxame na konec dolina i vivodime na goris."
      })
    }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.h2, {
      id: "levcenko-slovianski",
      children: "Rostislav Levčenko – Slovianski"
    }), "\n", _jsx(_components.h3, {
      id: "levcenko-lat",
      children: _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: "Naše selo"
      })
    }), "\n", _jsx(_components.div, {
      className: "notranslate",
      translate: "no",
      children: _jsx(_components.p, {
        children: "Iz vseh možlivih idealnih mest dl'a žitja, to ktore me naj više radosti, jest male selo daleke od šumnih grodov, male sosedstvo. Ono ne ima libojake prepolnene mnogo-komnatne domi, tol'ko male drevjane domeki – proste i ne mal'ovane mesta obitanja, s obitatel'ami čije obliča jesut dobro znane jak cveti v našem ogrode. To jest zatvoreni svet s nemnogimi individami blizko sojedinenimi – jak mrovki v mrovkovoj uzvisine, ili pčeli v pčelovom domeke, ili ovci v ovcovom domeke, ili mnihi v mnihskom dome, ili morniki na korabl'e; gde vsekto zna vseh i jest znani vsemi, interesuje se ob vseh, i može imat' nadeju što ine interesujut se ob im.\nJak radostno bilo bi zanurit' se v tut-te prave serdečne čuvstva milih i ne znajučih vliva privikov, i stretit' i sprijatel'it' se so vsemi človekami okolo nas, so vsemi ih unikal'nost'ami. Tak že mi budeme znat' i l'ubit' kuti i povroti tiničnih ulic i slonečnih lukov ktore mi minujeme vo vse dni.\nUvereno, mala social'na grupa, sel'ske sosedstvo jest' naj više dobro oceneno jak v poezie tak i v proze. Dloga rozt'agovana droga bludi se v milom parnom dne, prehodi veliku drogu vsekogda polnu vozami i konnikami. Či vi ne hočete putovat' so mnoju, dragi čitatel'? Putovanie ne bude dlogo. Mi počiname na konce dolini i vihodime na gori."
      })
    }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.h2, {
      id: "hintsala-slavski",
      children: "Jukka Hintsala – Slavski."
    }), "\n", _jsx(_components.h3, {
      id: "hintsala-lat",
      children: _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: "Naše selo"
      })
    }), "\n", _jsx(_components.div, {
      className: "notranslate",
      translate: "no",
      children: _jsx(_components.p, {
        children: "Iz vsou vozmozmou idealnou mestou živenja, to ktoro ja najviše volim, je malo selo daleko od šumlivou gradou, malo sosedstvo. Ono neima nekaki prepleni hohausi, tilko mali derevni budi – prosta i nemalovata mesta živenja, sa žitelnami koga lica su dobre znajomi kak kveti u naše dvore. To je zakritni mir sa nemnogami osobami blizko sajednitami – kak muraški u muraškove kupe, ili pčeli u pčelove gnezde, ili ovci u ovcove dome, ili monahi u monastire, ili moreki na loda: gde vsi zna vsou i je znajomi vsami, i interesa se o vsah, i može imati nadeždu čo drugi interesa se o im.\nKak prijatno bilbi njuriti se u etu serdecnu čuvstvu ljubovi i neznajuščou privikou i sastati se i sprijateljati se sa vsami čovekami okolo nas, sa im vsami jedinstvenami. Tako že mi budeme znati i ljubiti kuti i povroti tenistou ulicou i soncnou olukou, ktori mi prolazime vas dan.\nNaravno, mala socialna grupa, selovo sosedstvo je najviše dobre zadekata kak u poezie tak i u proze. Dolga razstegnata droga bludi se u mile parne dne, prehodi veliku drogu vsikada plenu vaditelji i jahatniki. Ne hočete li vi putovati sa meni, dragi čitateli? Putovanje ne bude dolgo. Mi počeme na konce dolini i vihodime na goru."
      })
    }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.h2, {
      id: "steenbergen-slovianski",
      children: "Jan van Steenbergen – Slovianski"
    }), "\n", _jsx(_components.h3, {
      id: "steenbergen-slovianski-lat",
      children: _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: "Naše selo"
      })
    }), "\n", _jsx(_components.div, {
      className: "notranslate",
      translate: "no",
      children: _jsx(_components.p, {
        children: "Iz vsih možlivih ideal’nih mest, v ktorih živut ljudi, ja najviše-mnogo ljubim male selo, daleko od šumnogo groda, s jego maloju společnostju. Ono ne ima prepolnenih blokov, tol’ko male drevjane budinki – proste i malovatel’ne mesto dlja žitja, s žiteljami, ktorih obliča sut rovno znajome kak cveti v našem sade. To je zatvoreni svet s nemnogo ljudami, blizko sojedinenimi kak mrovki v mrovkovoj kope, pčeli v pčel’nike, ovci v ovečkom gumne, muhi v mušskom gnezde ili morniki na korable, gde vsekto znaje vsekogo i vsekto je znani od vsekogo, gde každi interesuje sja v každom i každi može imat’ nadeju, čo inokto interesuje sja v nim.\nKak milo bilo bi zanurit’ sja v to serdečne čuvstvo ljubenija i neznanih običajov, sobrat’ sja i bit’ prijateli s timi vsimi jedinstvenimi ljudjami okolo nas! Tak, čo mi budeme znat’ i ljubit’ vse kuti i obroti tenjovih ulic i solnečne pokrivne kanali, prez ktore mi prehodime celi den’.\nLibokak, mala social’na grupa, ktora je sel’ska společnost’, je to, čemu poezija i proza djakujut najviše-mnogo. Dolga, roztjagnuta droga, bludžuča sja v milom, teplom dne i prehodžuča veliku, široku drogu polnu avt i tirov. Vi ne hočete putovat’ s mnoju, droge čitateli? Put’ ne bude dolga. Mi počeme na konce dolini i odtud poideme v goru."
      })
    }), "\n", _jsx(_components.h3, {
      id: "steenbergen-slovianski-cyr",
      children: _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: "Наше село"
      })
    }), "\n", _jsx(_components.div, {
      className: "notranslate",
      translate: "no",
      children: _jsx(_components.p, {
        children: "Из всих можливих идеальних мест, в кторих живут люди, я найвише-много любим мале село, далеко од шумного грода, с йего малою сполечностю. Оно не има преполнених блоков, только мале древяне будинки – просте и маловательне место для житя, с жителями, кторих облича сут ровно знайоме как цвети в нашем саде. То йе затворени свет с немного людами, близко сойединеними как мровки в мровковой копе, пчели в пчельнике, овци в овечком гумне, мухи в мушском гнезде или морники на корабле, где всекто знайе всекого и всекто йе знани од всекого, где кажди интересуйе ся в каждом и кажди може имать надею, чо инокто интересуйе ся в ним.\nКак мило било би занурить ся в то сердечне чувство любения и незнаних обичайов, собрать ся и бить приятели с тими всими йединственими людями около нас! Так, чо ми будеме знать и любить все кути и оброти теньових улиц и солнечне покривне канали, през кторе ми преходиме цели день.\nЛибокак, мала социальна група, ктора йе сельска сполечность, йе то, чему поезия и проза дякуют найвише-много. Долга, розтягнута дрога, блуджуча ся в милом, теплом дне и преходжуча велику, широку дрогу полну авт и тиров. Ви не хочете путовать с мною, дроге читатели? Путь не буде долга. Ми почеме на конце долини и одтуд поидеме в гору."
      })
    }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.h2, {
      id: "borovicka-slovioski",
      children: "Michal Borovička – Slovioski"
    }), "\n", _jsx(_components.h3, {
      id: "borovicka-lat",
      children: _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: "Našje selo"
      })
    }), "\n", _jsx(_components.div, {
      className: "notranslate",
      translate: "no",
      children: _jsx(_components.p, {
        children: "Iz vse možnih idealnih mestum, vo ktorih živjut ludi, ja najbolšju lubim maljo selo. dalkuo od šumnju grodu, s jego malju komunu, Ono ne ima perepolnih budovum , tolk malje drevnoje domi – prostjo i obraznjo mesto dla životu.\nSo obitateli ktorih lici jes zname kak cveti v našju sadu. To jes zakritnij svet s ne mnoguo ludim, bliznuo sojedinje kak muravi v muravju gnezdu, pčeli v pčeldomu, ovci v ovecnju ležku, muhi v muhovju gnezdu ili korabniki na korabu, gde vse znajut vse i vse jes znat od vse gde každij se interesi o každum i každij moži imat nadežu, že nekto ineteresi o jemu.\nKak miluo bilo bi se zanurit v to sercevnju čudostu lubeznih i neznavih privikum, vzat se i bit priatel so vse unikatnih ludimi okol nam.\nŠto mi budeme znat i lubovit vse kuti i obrot ulicum i suncovje obmanje kanali črez ktorje mi prehodime celij den.\nLibo malja socialnja grupa, kak jes selonja komuna, jes to što poezia i proza hvalit najbolšie. Dolgja razširenja doroga, ktorja bludi se v milju teplju denu i prohodi vo širju dorogu polnju automobilum i kamionum.\nVi ne hocete putovat se mnu, dragoje čitateli?\nPut ne bude dolgja. Mi načime na koncu dolinu i ot tut mi budeme idit v goru."
      })
    }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.h2, {
      id: "polyakov-slovianski",
      children: "Igor Polyakov – Slovianski"
    }), "\n", _jsx(_components.h3, {
      id: "polyakov-lat",
      children: _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: "Naše selo"
      })
    }), "\n", _jsx(_components.div, {
      className: "notranslate",
      translate: "no",
      children: _jsx(_components.p, {
        children: "Iz vseh idealnih mest, gde živut ludi, ja najviše lubju maleńke seło. Daleko od šumnogo groda, s jego maleńkoj jednostju, ono ne ima prepołnenih budinkov; tolko malenki drevjane doma – proste i obrazcove mesto dla žitija.\nSožiteli ktorih obličija su znani jak cveti v našom sadu. To je tajni svet s ne mnogo luďami, blizko sojedine jak mrovki v mrovńake, pčeli v ule, ovci v stade, muški v muškovom gnezde. Abo jak mornari na korabe, gde vse znajut vseh i každi jesť znani vsemi; gde vse su zainteresovani vsemi i každi može imať nadežu što nekto bude zainteresovani v nim.\nKak milo bi bilo bi okružiť śa serdečnoj čudnostju lubeznih i neznanih običajov, zvať śa i bit prijatelem so vsemi unikalnimi luďami vokrug nas? Mi budeme znať i lubiť vse ugli i obroti ulic i solnečne ložne kanali prez ktore mi prehodime cełi deń.\nLuba maleńka socialna grupa, jak selska jednosť, je to što poezija i proza hvalit najviše. Dolga rozširena droga, ktora izviva śa v miłom teplom dni i prohodi v široku drogu połnu avto i kamionami. Vi ne hočite putovať so mnoj, drogi čitateli? Puť ne bude dolgim. Mi počneme na konce dolini i ot tut mi budeme iti v verh."
      })
    }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.h4, {
      id: "later-additions",
      children: "After the conclusion of the Relay game, a few translations have been added afterwards:"
    }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.h2, {
      id: "merunka-novoslovienski",
      children: "Vojtěch Merunka – Novoslovienski"
    }), "\n", _jsx(_components.h3, {
      id: "merunka-novoslovienski-lat",
      children: _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: "Naše selo"
      })
    }), "\n", _jsx(_components.div, {
      className: "notranslate",
      translate: "no",
      children: _jsx(_components.p, {
        children: "Iz vsih možnih idealnih miest, v ktorih žijut ljudi, najbolie ljubiu male selo, daleko od šumnego grada, s jego maloj obštinoj. Ono ne imaje prep‘lnienih blokov, samo male d‘rvene budinky. Jest to proste i malovatielne miesto za života, s žitielami, ktorih lica sut rovno znajemi jako cviety v našem sadie. To jest zatvorienij sviet s nemnogo ljudiami, blizko s‘jedinenimi jako mravky v mravkovej kopie, pčely v pčel’nikie, ovcy v ovcem gumnie, monašky v monastirie ili morniki na korabie, gdie vsij znaje vsego i vse je znane ot vsego, gdie vsij se interesuje v vsem i vsij može imati nadeju, že niekto se v niem interesuje.\nJako mile by bylo zanoriti se v to s‘rdečne čuvstvo ljubienia i neznamih obyčajov, s‘brati se i byti priateli s tiemi vsimi jedinstvenimi ljudiami okolo nas! Tako, že my budeme znati i ljubiti vsi zakuty i povraty tenkih ulic i s‘lncom pokryti luki, črez koježe my prehodime vsij den. Mala socialna gruppa, iže jest selska obština, jest to, čemuže poezia i proza blagodari najbolie. D‘lga, roztiagnuta droga, bludiušta se v milem, teplem dni i preidušta veliku, široku drogu p‘lnu aut‘ i tirov. Ne hočete li putovati s mnoj, dragij čitatieli? Put ne bude d‘lga. My počneme na koncie doliny i ot‘tamo poideme v goru."
      })
    }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.h2, {
      id: "steenbergen-slovianto",
      children: "Jan van Steenbergen – Slovianto"
    }), "\n", _jsx(_components.h3, {
      id: "steenbergen-slovianto-lat",
      children: _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: "Naš selo"
      })
    }), "\n", _jsx(_components.div, {
      className: "notranslate",
      translate: "no",
      children: _jsx(_components.p, {
        children: "Iz vse možlive mesti, v ktore živet liudi, ja najviše-mnogo liubim male selo, daleko od šumne grod, s jego male společnost. Ono ne imat prepolniene bloki, jedino male drevenne budinki. Jest to proste i malovatelne mesto dlia žitie, s žiteli, čij lici jest rovno znane kak cveti v naš sad. To jest zatvoriene svet s nemnogo liudi, blizko sojediniene kak mrovki v mrovske kopa, pčeli v pčelnik, ovci v ovčarnia, mniški v konvent, ili morniki na korabia, gde vsekto znat vsekogo i vsekto jest znane od vsekogo, gde vsekto interesujet se v vsekogo i vsekto možet imati nadeja, čo nekto interesujet se v njego.\nKak milo bilo bi zanuriti se v te serdečne čutie od liubienie i neznane običaji, sobrati se i biti prijateli s te vse jedinstvene liudi okolo nas! Tak, čo mi budem znati vse zakutki i povroti od tenke ulici i solnečne luki, ktore mi prohodim každe den. Male socialne grupa, ktore jest selske společnost, jest to, za čo poezija i proza diakujet najviše-mnogo. Dolge, roztiagnute droga, bludijuče se v mile, teple den i preiduče prez velike, široke droga, polne od avti i tiri. Li vi ne hočete putovati s mene, droge čitateli? Put ne budet dolge. Mi počam na konec od dolina i odtude mi poidem v gora."
      })
    }), "\n", _jsx(_components.h3, {
      id: "steenbergen-slovianto-cyr",
      children: _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: "Наш село"
      })
    }), "\n", _jsx(_components.div, {
      className: "notranslate",
      translate: "no",
      children: _jsx(_components.p, {
        children: "Из все можливе мести, в кторе живет люди, я найвише-много любим мале село, далеко од шумне грод, с его мале сполечност. Оно не имат преполньене блоки, едино мале древенне будинки. Ест то просте и малователне место для житье, с жители, чий лици ест ровно знане как цвети в наш сад. То ест затворьене свет с немного люди, близко соединьене как мровки в мровске копа, пчели в пчелник, овци в овчарня, мнишки в конвент, или морники на корабя, где всекто знат всекого и всекто ест знане од всекого, где всекто интересует се в всекого и всекто может имати надея, чо некто интересует се в него.\nКак мило било би занурити се в те сердечне чутье од любьенье и незнане обичаи, собрати се и бити приятели с те все единствене люди около нас! Так, чо ми будем знати все закутки и повроти од тенке улици и солнечне луки, кторе ми проходим кажде ден. Мале социалне група, кторе ест селске сполечност, ест то, за чо поэзия и проза дякует найвише-много. Долге, розтягнуте дрога, блудиюче се в миле, тепле ден и преидуче през велике, широке дрога, полне од авти и тири. Ли ви не хочете путовати с мене, дроге читатели? Пут не будет долге. Ми почам на конец од долина и одтуде ми поидем в гора."
      })
    }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.h2, {
      id: "merunka-novoslovienski-reformed",
      children: "Vojtěch Merunka – Novoslovienski (reformed)"
    }), "\n", _jsx(_components.h3, {
      id: "merunka-novoslovienski-reformed-lat",
      children: _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: "Naše selo"
      })
    }), "\n", _jsx(_components.div, {
      className: "notranslate",
      translate: "no",
      children: _jsx(_components.p, {
        children: "Iz vsih možnih idealnih miest, v kojihže žijut ljudi, najbolie ljubiu male selo, daleko ot šumnego grada, s jego maloj obštinoj. Ono ne imaje prep‘lnieni bloky, samo male d‘rvene budniky. Jest to proste i slične miesto za života, s žitieljami, ktorih lica sut rovno znajemi jako cviety v našem sadie. To jest zatvorienij sviet s nemnogo ljudiami, blizko s‘jednienimi jako mravky v mravkovej kupie, pčely v pčelnikie, ovcy v ovcej štalie, monahi v monastirie ili morjaki na korabie, gdie vsij znaje vsego i vse jest znane ot vsego, gdie vsij se interesuje v vsim i vsij može imati nadeju, že niekto se v niem interesuje.\nJako drago by bylo zanoriti se v to s‘rdečne čuvstvo ljubienia i neznamih upotreb, s‘brati se i byti kolegy s tiemi vsimi jedinstvenimi ljudimi okolo nas! Tako, že my budeme znati i ljubiti vsi zakuty i povraty tenkih ulic i s‘lncom pokryti luki, črez koježe budeme hoditi vsij den ot jutra do večera. Mala socialna gruppa, iže jest selska obština, jest to, čemuže poezia i proza blagodari najbolie. Ide tamo uzka droga, iže v lepem teplem dni prehodi veliku široku drogu p‘lnu aut i tirov. Ne hočete li putovati s mnoj, dragij čitatieli? Put ne bude d‘lga. My budeme putovati ot počatku doliny i ot‘tamo ideme nagorie."
      })
    }), "\n", _jsx(_components.h3, {
      id: "merunka-novoslovienski-reformed-cyr",
      children: _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: "Наше село"
      })
    }), "\n", _jsx(_components.div, {
      className: "notranslate",
      translate: "no",
      children: _jsx(_components.p, {
        children: "Из всих можних идеалних міест, в койихже жийут људи, найболіе љубю мале село, далеко от шумнего града, с єго малой общиной. Оно не имайе препълніени блокы, само мале дървене будники. Єст то просте и сличне міесто за живота, с житіељами, кторих лица сут ровно знайеми яко цвіеты в нашем садіе. То іест затворіеній свіет с немного људіами, близко съйедніеними яко мравки в мравковей купіе, пчелы в пчелникіе, овцы в овцей шталіе, монахи в монастиріе или морьаки на корабіе, гдіе всій знайе всего и все єст знане от всего, гдіе всій се интересуйе в всим и всій може имати надейу, же ніекто се в ніем интересуйе.\nЯко драго бы было занорити се в то сърдечне чувство љубіеніа и незнамих употреб, събрати се и быти колегы с тіеми всими єдинственими људими около нас! Тако, же мы будеме знати и љубити вси закуты и повраты тенких улиц и сълнцом покрыти луки, чрез койеже будеме ходити всій ден от ютра до вечера. Мала социална группа, иже єст селска община, єст то, чемуже поезия и проза благодари найболіе. Иде тамо узка дрога, иже в лепем теплем дни преходи велику широку дрогу пълну аут и тиров. Не хочете ли путовати с мной, драгій читатіели? Пут не буде дълга. Мы будеме путовати от початку долины и отътамо идеме нагоріе."
      })
    }), "\n", "\n", _jsx(CustomAfterSection, {})]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}

